// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"803":"d7902780","889":"6c729fd8"}[chunkId] + ".chunk.js";
};